import styled, { css } from 'styled-components';
import Picture from 'components/mediabay-ui/components/Picture';
import Heading from 'components/mediabay-ui/components/Heading';
import fadeIn from '../../fadeInAnim';

export const Container = styled.div`
  background: ${props => `url(${props.backgroundUrl})`};
  background-size: cover;
  background-attachment: fixed;
  min-height: 50vh;
  padding: 5% 5% 0;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  @media (min-width: 768px) {
    justify-content: space-between;
  }

  @media (min-width: 1024px) {
    justify-content: flex-start;
  }
`;

export const DetailsPicture = styled(Picture)`
  margin: 30px 0;

  @media (min-width: 768px) {
    flex: 0 1 auto;
    margin: 0;
  }

  @media (min-width: 1024px) {
    margin-right: 50px;
  }
`;

export const DescriptionWrapper = styled.div`

  @media (min-width: 768px) {
    flex: 0 1 60%;
  }
`;

const headingStyles = css`
  text-align: center;
  margin: 0;
  line-height: 1.4;
  animation: ${fadeIn};

  @media (min-width: 768px) {
    text-align: left;
  }
`;

export const DetailsHeading = styled(Heading)`
  font-size: 2rem;
  text-transform: uppercase;
  ${headingStyles}
`;

export const DetailsSubheading = styled.div`
  font-size: 18px;
  ${headingStyles}
`;

export const DetailsList = styled.ul`
  display: flex;
  justify-content: center;
  list-style-type: none;
  font-size: 20px;
  margin: 10px 0 0 0;
  padding: 0;
  animation: ${fadeIn};

  li {
    display: flex;
    align-items: center;
    margin-right: 15px;

    &:last-child { margin: 0 }
  }

  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`;

export const DetailsDescription = styled.div`
  font-size: 16px;
  line-height: 1.2;
  animation: ${fadeIn};
`;

export const DetailsNameTitle = styled.p`
  margin: 5px 0;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
`;
